module.exports = __webpack_public_path__ + "img/me.f647164c.jpg";